import { dateFormatter } from './formatters/date';

type Period = {
  start: string | Date;
  end: string | Date;
};

export function periodIntervalFormatter(period: Period) {
  const startTime = dateFormatter(period.start, 'HH:mm');
  const endTime = dateFormatter(period.end, 'HH:mm');
  return `${startTime} às ${endTime}`;
}
